<script setup>
import Modal from "./Modal.vue";

const emit = defineEmits(["close"]);

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    maxWidth: {
        type: String,
        default: "2xl",
    },
    closeable: {
        type: Boolean,
        default: true,
    },
});

const close = () => {
    emit("close");
};

// this is dialog modal code preset to use anywhere else:
/*

import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import DialogModal from "@/Components/DialogModal.vue";
import JetButton from "@/Components/PrimaryButton.vue";

const modalNameVisible = ref(null);
const modalNameVisibleForm = useForm({
    data: null,
});

function modalNameVisibleFormSubmit() {
    modalNameVisibleForm.post(route(`modalNameVisibleForm`), {
        preserveScroll: true,
        onSuccess: (response) => {
            // console.log(response);
            modalNameVisible.value = null;
        },
    });
}

*/
</script>

<!--this is dialog modal code preset to use anywhere else:-->
<!--<dialog-modal
    :show="modalNameVisible != null"
    @close="modalNameVisible = null"
>
<template #title>TITLE</template>

<template #content>
    <div class="mt-4">contents</div>
</template>

<template #footer>
    <Button
        color="white"
        @click="modalNameVisible = null"
    >
        Cancel
    </Button>
    <jet-button
        class="ml-3"
        :class="{ 'opacity-25': modalNameVisibleForm.processing }"
        :disabled="modalNameVisibleForm.processing"
        @click="modalNameVisibleFormSubmit()"
    >
        <span>Submit</span>
    </jet-button>
</template>
</dialog-modal>-->

<template>
    <Modal
        :show="show"
        :max-width="maxWidth"
        :closeable="closeable"
        @close="close"
    >
        <div class="px-6 py-4">
            <div class="text-lg">
                <slot name="title" />
            </div>

            <div class="mt-4">
                <slot name="content" />
            </div>
        </div>

        <div class="flex flex-row justify-end bg-gray-100 px-6 py-4 text-right">
            <slot name="footer" />
        </div>
    </Modal>
</template>
